import { createSlice } from '@reduxjs/toolkit';

export type ShowPhoneFormState = {
  isFormOpen: boolean;
  isShowPhoneButtonDisabled: boolean;
  isPhoneDisplayed: boolean;
};

export const initialState: ShowPhoneFormState = {
  isFormOpen: false,
  isShowPhoneButtonDisabled: false,
  isPhoneDisplayed: false
};

const showPhoneForm = createSlice({
  name: 'showPhoneForm',
  initialState,
  reducers: {
    reset: () => {
      return initialState;
    },
    openModalForm: (state) => {
      state.isFormOpen = true;
      state.isShowPhoneButtonDisabled = true;
    },
    closeModalForm: (state) => {
      state.isFormOpen = false;
      state.isShowPhoneButtonDisabled = false;
    },
    showPhone: (state) => {
      state.isPhoneDisplayed = true;
      state.isShowPhoneButtonDisabled = true;
      state.isFormOpen = false;
    }
  }
});

export const { openModalForm, closeModalForm, showPhone, reset } =
  showPhoneForm.actions;
export default showPhoneForm.reducer;
